import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeHeaderDesktop } from './desktop';
import { FixedFeeHeaderMobile } from './mobile';

export interface FixedFeeHeaderProps {
  hasSomeImpersonation: boolean;
}

export const FixedFeeHeader: React.FC<FixedFeeHeaderProps> = ({ hasSomeImpersonation }) => {
  return useBreakpointValue({
    base: <FixedFeeHeaderMobile hasSomeImpersonation={hasSomeImpersonation} />,
    sm: <FixedFeeHeaderDesktop hasSomeImpersonation={hasSomeImpersonation} />,
  });
};
